import React from 'react'
import { Box, Popover, Typography } from '@mui/material'
import more from '../../assets/images/more-icon.png'

interface IPopOverCancelForDesctop {
  handleOpen: (priceId: string, productId: string, name: string, interval: string, category: string) => void
  priceId: string
  productId: string
  name: string
  interval: string
  category: string
}

const PopOverCancelForDesctop = ({ handleOpen, priceId, productId, name, interval, category }: IPopOverCancelForDesctop) => {
  const [anchorEl, setAnchorEl] = React.useState<any>(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  return (
        <>
            <Box onClick={handleClick} sx={{ cursor: 'pointer' }} component='img' src={more} />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center'
                }}
            >
                <Typography
                    onClick={() => {
                      handleOpen(priceId, productId, name, interval, category)
                      handleClose()
                    }}
                    sx={{ p: 2, cursor: 'pointer' }}>
                    Cancel
                </Typography>
            </Popover>
        </>
  )
}

export default PopOverCancelForDesctop
